import React from 'react'

const Footer = () => {
  return (
    <footer>
        <ul>
          <li>
            <a href="#">Register</a>
          </li>
          <li>
            <a href="#">Forum</a>
          </li>
          <li>
            <a href="#">Affiliate</a>
          </li>
          <li>
            <a href="#">FAQ</a>
          </li>
        </ul>
        <div className="icons">
          <i class="fa-brands fa-facebook"></i>
          <i class="fa-brands fa-twitter"></i>
          <i class="fa-brands fa-instagram"></i>
          <i class="fa-brands fa-dribbble"></i>
          <i class="fa-brands fa-linkedin-in"></i>
        </div>
        <p>© 2021. Foodera. All rights reserved.</p>
      </footer>
  )
}

export default Footer